import type { SeniorityLevelTuple } from '@/services/external-offers';

import { capitalizeFirstLetter } from './cvGenerator';

export const getOfferChips = ({
  isHybrid,
  isOnsite,
  isRemote,
  seniorityLevel,
}: {
  isHybrid: boolean;
  isOnsite: boolean;
  isRemote: boolean;
  seniorityLevel: SeniorityLevelTuple;
}) =>
  [
    capitalizeFirstLetter(seniorityLevel),
    isHybrid ? 'Hybrid' : '',
    isOnsite ? 'On-site' : '',
    isRemote ? 'Remote' : '',
  ].filter((chip) => chip);
